<template>
  <layout>
    <template slot="header"
      >Edit {{ properties[0].groupName.toLowerCase() }}</template
    >
    <div style="height: 100%; overflow: auto">
      <template v-for="item in propertiesLocal">
        <template v-if="!item.spec.valueSet && !item.spec.valueRange">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            :data-test-select="item.property"
            :label="`${item.title}`"
            :key="item.id"
            v-model="item.value"
            v-if="isBoolean(item.spec.typeId)"
            item-value="id"
            item-text="name"
            :items="[
              { id: true, name: 'true' },
              { id: false, name: 'false' },
              { id: null, name: 'null' }
            ]"
            class="px-4 pb-4"
          >
            <template v-slot:item="{ item: i }">
              <div :data-test-select-value="`${item.title}:${i.name}`">
                {{ i.name }}
              </div>
            </template>
          </v-select>

          <div v-else-if="isJson(item.spec.typeId)" :key="item.id">
            <v-card-text>
              {{ item.title }}
            </v-card-text>
            <code-editor
              v-model="item.value"
              @is-error="isCodeError = $event"
              :code="getCode(item)"
            ></code-editor>
          </div>
          <template v-else>
            <v-text-field
              :data-test="item.property"
              v-if="isNumber(item.spec.typeId)"
              :key="item.id"
              type="number"
              class="px-4"
              :label="item.title"
              clearable
              :placeholder="item.property"
              v-model.number="item.value"
            ></v-text-field>
            <v-text-field
              :data-test="item.property"
              v-else
              :key="item.id"
              class="px-4"
              :label="item.title"
              clearable
              :placeholder="item.property"
              v-model="item.value"
            ></v-text-field>
          </template>
        </template>
        <template v-else>
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            :data-test-select="item.property"
            :key="item.id"
            v-if="
              item.spec.valueSet && item.spec.valueSet.component === 'select'
            "
            v-model="item.value"
            item-value="key"
            class="px-4 pb-4"
            item-text="title"
            :items="item.spec.valueSet.list"
          >
            <template v-slot:item="{ item: i }">
              <div :data-test-select-value="`${item.title}:${i.title}`">
                {{ i.title }}
              </div>
            </template>
          </v-select>
          <v-text-field
            :data-test="item.property"
            :key="item.id"
            v-else-if="item.spec.valueSet"
            v-model="item.value"
            class="px-4 pb-4"
          ></v-text-field>
          <v-text-field
            :data-test="item.property"
            :key="item.id"
            v-if="item.spec.valueRange"
            v-model.number="item.value"
            class="px-4 pb-4"
            :max="item.spec.valueRange.max"
            :min="item.spec.valueRange.min"
            type="number"
          ></v-text-field>
        </template>
      </template>
    </div>
    <template slot="footer">
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')">Cancel</v-btn>
      <v-btn
        color="primary"
        data-test="saveProperties"
        text
        @click="saveHandler"
        >save</v-btn
      >
    </template>
  </layout>
</template>

<script>
import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import sortBy from 'lodash.sortby';
import cloneDeep from 'lodash.clonedeep';

import Layout from '@/layouts/LayoutPopup';
import gql from '@/api/objects/item.graphql';

import CodeEditor from '@/components/CodeEditor';
import { isBoolean, isJson, isNumber } from '@/utils/getCurrentType';

export default defineComponent({
  name: 'EditProperties',
  components: { Layout, CodeEditor },
  props: {
    properties: {
      type: Array,
      required: true
    },
    objectId: {
      type: String,
      required: true
    }
  },
  setup(props, { emit }) {
    const { mutate: changeProperties } = useMutation(
      gql.updateObjectProperties
    );

    const propertiesLocal = ref();

    const close = () => {
      emit('close');
    };

    const saveHandler = () => {
      let cloneProperties = cloneDeep(propertiesLocal.value);

      const convertJson = value => {
        try {
          return JSON.parse(value);
        } catch (e) {
          return value;
        }
      };
      let data = cloneProperties.map(item => ({
        value: convertJson(item.value),
        propertyId: item.id
      }));
      changeProperties({
        input: {
          propertiesArray: data
        }
      }).then(() => {
        close();
      });
    };

    const getCode = itemLocal => {
      return JSON.stringify(
        props.properties.find(item => item.id === itemLocal.id).value
      );
    };
    const handleInputCode = (e, item) => {
      item.value = e;
    };

    onMounted(() => {
      console.log(sortBy(cloneDeep(props.properties), 'title'));
      propertiesLocal.value = sortBy(cloneDeep(props.properties), 'title');
    });

    return {
      propertiesLocal,
      saveHandler,
      isJson,
      isBoolean,
      isNumber,
      getCode,
      handleInputCode
    };
  }
});
</script>
